import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'src/app/services/account.service';
import { User } from 'src/app/models/user';
import { Subscription } from 'rxjs';
import { Apollo, QueryRef } from 'apollo-angular';
import { GetPermissions, PermissionNode } from 'src/app/services/account.service';

interface FuntionalityNode {
  name: string;
  children?: FuntionalityNode[];
}

interface FuntionalityNodeName {
  nodeName: string;
}


interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-layout',
  templateUrl: './app.layout.html',
  styleUrls: ['./app.layout.css']
})
export class AppLayout {
  user: User = new User("", "", "", "", "","");
  showFiller = false;
  opened: boolean;
  private _transformer = (node: FuntionalityNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level
    };
  };

  treeControl = new FlatTreeControl<FlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  TREE_DATA: FuntionalityNode[];
  TREE_INITIAL_DATA: FuntionalityNode[];
  TREE_DATA_MANAGERS: FuntionalityNode[];
  TREE_DATA_PATIENT: FuntionalityNode[];
  TREE_DATA_ADMIN: FuntionalityNode[];
  TREE_NOT_PERMISSION: FuntionalityNode[];
  TREE_DATA_REPORT: FuntionalityNode[];
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  querySubscription: Subscription;
  queryPost: QueryRef<any>;
  permissionList: PermissionNode[];
  adm_label: string;
  pat_label: string;
  sec_label: string;
  user_label: string;
  grop_label: string;
  proj_label: string;
  rept_label: string;
  meas_label: string;
  surv_label: string;
  clins_label: string;
  load_label: string;
  noperm_label: string;
  browserLang: string;

  constructor(private accountService: AccountService, private router: Router, private apollo: Apollo, private translate: TranslateService) {
    this.accountService.user.subscribe(x => this.user = x);
    this.browserLang = navigator.language || navigator.languages[0];
    this.opened = false;
    let sidenav_state = localStorage.getItem('sidenav');
    if (sidenav_state) {
      this.opened = JSON.parse(sidenav_state);
    } else {
      localStorage.setItem("sidenav", "false");
    }
    this.querySubscription = Subscription.EMPTY;
    this.queryPost = this.apollo
      .watchQuery<any>({
        query: GetPermissions,
        fetchPolicy: 'network-only'
      });
    this.permissionList = [];
    this.adm_label = "";
    this.pat_label = "";
    this.sec_label = "";
    this.user_label = "";
    this.grop_label = "";
    this.proj_label = "";
    this.rept_label = "";
    this.meas_label = "";
    this.surv_label = "";
    this.clins_label = "";
    this.load_label = "";
    this.noperm_label = "";
    this.TREE_DATA = [
      {
        name: '{ "nodeName": "Administration" }',
        children: [
          {
            name: '{ "nodeName": "Security" }',
            children: [
              {
                name: '{ "nodeName": "Users", "route": "users" }'
              }, {
                name: '{ "nodeName": "Groups", "route": "groups" }'
              }, {
                name: '{ "nodeName": "Audits", "route": "audits" }'
              }],
          },
          {
            name: '{ "nodeName": "Ecrf" }',
            children: [
              {
                name: '{ "nodeName": "Project", "route": "projects" }',
              },
              {
                name: '{ "nodeName": "Clinical studies", "route": "clinical-studies" }',
              },
              {
                name: '{ "nodeName": "Measurements", "route": "measurements" }'
              }
            ],
          }],
      },
      {
        name: '{ "nodeName": "Participants", "route": "patients" }'
      },
      {
        name: '{ "nodeName": "Reports" }',
        children: [
          {
            name: '{ "nodeName": "Ecrf", "route": "reports/project" }'
          },
          {
            name: '{ "nodeName": "Measurements", "route": "reports/measurement" }'
          },
          {
            name: '{ "nodeName": "Survey", "route": "reports/survey" }'
          }
        ]
      },
    ];
    this.TREE_INITIAL_DATA = [
      {
        name: '{ "nodeName": "Loading...." }',
        children: []
      }
    ];
    this.dataSource.data = this.TREE_INITIAL_DATA;
    this.TREE_DATA_MANAGERS = [
      {
        name: '{ "nodeName": "Participants", "route": "patients" }'
      },
      {
        name: '{ "nodeName": "Reports" }',
        children: [
          {
            name: '{ "nodeName": "Ecrf", "route": "reports/project" }'
          },
          {
            name: '{ "nodeName": "Measurements", "route": "reports/measurement" }'
          },
          {
            name: '{ "nodeName": "Survey", "route": "reports/survey" }'
          }
        ]
      },
    ];
    this.TREE_DATA_PATIENT= [
      {
        name: '{ "nodeName": "Participants", "route": "patients" }'
      }
    ];
    this.TREE_DATA_ADMIN = [
      {
        name: '{ "nodeName": "Administration" }',
        children: [
          {
            name: '{ "nodeName": "Security" }',
            children: [
              {
                name: '{ "nodeName": "Users", "route": "users" }'
              }, {
                name: '{ "nodeName": "Groups", "route": "groups" }'
              }, {
                name: '{ "nodeName": "Audits", "route": "audits" }'
              }],
          },
          {
            name: '{ "nodeName": "Ecrf" }',
            children: [
              {
                name: '{ "nodeName": "Project", "route": "projects" }',
              },
              {
                name: '{ "nodeName": "Clinical studies", "route": "clinical-studies" }',
              }
            ],
          }],
      }
    ];
    this.TREE_NOT_PERMISSION = [
      {
        name: '{ "nodeName": "No permission" }',
        children: []
      }
    ];
    this.TREE_DATA_REPORT = [
      {
        name: '{ "nodeName": "Reports" }',
        children: [
          {
            name: '{ "nodeName": "Ecrf", "route": "reports/project" }'
          },
          {
            name: '{ "nodeName": "Measurements", "route": "reports/measurement" }'
          },
          {
            name: '{ "nodeName": "Survey", "route": "reports/survey" }'
          }
        ]
      }
    ];
    if (this.browserLang?.toLowerCase().startsWith('it')) {
      this.useLanguage('it');
    } else {
      this.useLanguage('en');
    }
  }

  getData() {
    this.querySubscription = this.queryPost.valueChanges.subscribe(({ data, loading, error }) => {
      if (data.getPermissions) {
        this.permissionList = data.getPermissions;
        localStorage.setItem("permissionList", JSON.stringify(this.permissionList));
      }
      this.setPermissionTree();
    });
  }

  updateNodes() {
    let value: FuntionalityNodeName = JSON.parse(this.TREE_DATA[0].name) as FuntionalityNodeName;
    value.nodeName = this.adm_label;
    this.TREE_DATA[0].name = JSON.stringify(value);
    value = JSON.parse(this.TREE_DATA[1].name) as FuntionalityNodeName;
    value.nodeName = this.pat_label;
    this.TREE_DATA[1].name = JSON.stringify(value);
    if (this.TREE_DATA[0].children) {
      value = JSON.parse(this.TREE_DATA[0].children[0].name) as FuntionalityNodeName;
      value.nodeName = this.sec_label;
      this.TREE_DATA[0].children[0].name = JSON.stringify(value);
    }
    if (this.TREE_DATA[0].children) {
      if (this.TREE_DATA[0].children[0].children) {
        value = JSON.parse(this.TREE_DATA[0].children[0].children[0].name) as FuntionalityNodeName;
        value.nodeName = this.user_label;
        this.TREE_DATA[0].children[0].children[0].name = JSON.stringify(value);
      }
    }
    if (this.TREE_DATA[0].children) {
      if (this.TREE_DATA[0].children[0].children) {
        value = JSON.parse(this.TREE_DATA[0].children[0].children[1].name) as FuntionalityNodeName;
        value.nodeName = this.grop_label;
        this.TREE_DATA[0].children[0].children[1].name = JSON.stringify(value);
      }
    }
    if (this.TREE_DATA[0].children) {
      if (this.TREE_DATA[0].children[1].children) {
        value = JSON.parse(this.TREE_DATA[0].children[1].children[0].name) as FuntionalityNodeName;
        value.nodeName = this.proj_label;
        this.TREE_DATA[0].children[1].children[0].name = JSON.stringify(value);
      }
    }
    value = JSON.parse(this.TREE_DATA[2].name) as FuntionalityNodeName;
    value.nodeName = this.rept_label;
    this.TREE_DATA[2].name = JSON.stringify(value);
    if (this.TREE_DATA[2].children) {
      value = JSON.parse(this.TREE_DATA[2].children[1].name) as FuntionalityNodeName;
      value.nodeName = this.meas_label;
      this.TREE_DATA[2].children[1].name = JSON.stringify(value);
      value = JSON.parse(this.TREE_DATA[2].children[2].name) as FuntionalityNodeName;
      value.nodeName = this.surv_label;
      this.TREE_DATA[2].children[2].name = JSON.stringify(value);
    }
    if (this.TREE_DATA[0].children) {
      if (this.TREE_DATA[0].children[1].children) {
        value = JSON.parse(this.TREE_DATA[0].children[1].children[1].name) as FuntionalityNodeName;
        value.nodeName = this.clins_label;
        this.TREE_DATA[0].children[1].children[1].name = JSON.stringify(value);
      }
    }
    if (this.TREE_DATA[0].children) {
      if (this.TREE_DATA[0].children[1].children) {
        value = JSON.parse(this.TREE_DATA[0].children[1].children[2].name) as FuntionalityNodeName;
        value.nodeName = this.meas_label;
        this.TREE_DATA[0].children[1].children[2].name = JSON.stringify(value);
      }
    }
    value = JSON.parse(this.TREE_INITIAL_DATA[0].name) as FuntionalityNodeName;
    value.nodeName = this.load_label;
    this.TREE_INITIAL_DATA[0].name = JSON.stringify(value);
    value = JSON.parse(this.TREE_DATA_MANAGERS[0].name) as FuntionalityNodeName;
    value.nodeName = this.pat_label;
    this.TREE_DATA_MANAGERS[1].name = JSON.stringify(value);
    value = JSON.parse(this.TREE_DATA_MANAGERS[1].name) as FuntionalityNodeName;
    value.nodeName = this.rept_label;
    this.TREE_DATA_MANAGERS[1].name = JSON.stringify(value);
    if (this.TREE_DATA_MANAGERS[1].children) {
      value = JSON.parse(this.TREE_DATA_MANAGERS[1].children[1].name) as FuntionalityNodeName;
      value.nodeName = this.meas_label;
      this.TREE_DATA_MANAGERS[1].children[1].name = JSON.stringify(value);
      value = JSON.parse(this.TREE_DATA_MANAGERS[1].children[2].name) as FuntionalityNodeName;
      value.nodeName = this.surv_label;
      this.TREE_DATA_MANAGERS[1].children[2].name = JSON.stringify(value);
    }
    if (this.TREE_DATA_REPORT[0].children) {
      value = JSON.parse(this.TREE_DATA_REPORT[0].children[2].name) as FuntionalityNodeName;
      value.nodeName = this.surv_label;
      this.TREE_DATA_REPORT[0].children[2].name = JSON.stringify(value);
    }
    value = JSON.parse(this.TREE_DATA_PATIENT[0].name) as FuntionalityNodeName;
    value.nodeName = this.pat_label;
    this.TREE_DATA_PATIENT[0].name = JSON.stringify(value);
    value = JSON.parse(this.TREE_NOT_PERMISSION[0].name) as FuntionalityNodeName;
    value.nodeName = this.noperm_label;
    this.TREE_NOT_PERMISSION[0].name = JSON.stringify(value);
    this.setPermissionTree();
  }

  ngOnInit() {
    this.accountService.verifyToken();
    this.getData();
  }

  setPermissionTree() {
    if (this.permissionList.length == 0) {
      this.dataSource.data = this.TREE_NOT_PERMISSION;
    }
    let admin: boolean = false;
    let patient: boolean = false;
    let manager: boolean = false;
    let report: boolean = false;
    for (let permission of this.permissionList) {
      if (permission.codename == "add_project") {
        admin = true;
      }
      if (permission.codename == "view_measurementreport") {
        report = true;
      }
      if (permission.codename == "add_patient" || permission.codename == "view_patient") {
        patient = true;
      }
      if (patient && report) {
        manager = true;
        patient = false;
        report = false;
      }
    }
    if (admin && !patient) {
      this.dataSource.data = this.TREE_DATA_ADMIN;
    } else if (admin && patient) {
      this.dataSource.data = this.TREE_DATA;
    } else if (manager) {
      this.dataSource.data = this.TREE_DATA_MANAGERS;
    } else if (report) {
      this.dataSource.data = this.TREE_DATA_REPORT;
    }
    else {
      this.dataSource.data = this.TREE_DATA_PATIENT;
    }
  }

  logout() {
    this.accountService.logout();
  }

  goChangePass() {
    this.router.navigate(['/users/change-passw']);
  }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  goRoute(nodeData: string) {
    this.router.navigate([JSON.parse(nodeData).route]);
  }

  getNodeName(nodeData: string) {
    return JSON.parse(nodeData).nodeName;
  }

  goHome() {
    this.router.navigate(['/']);
  }

  sideNavOpen() {
    localStorage.setItem("sidenav", "true");
  }

  sideNavClose() {
    localStorage.setItem("sidenav", "false");
  }

  useLanguage(language: string): void {
    this.translate.use(language);
    this.translate.get('NoP').subscribe({
      next: (res: string) => {
        this.noperm_label = res;
      }
    });
    this.translate.get('LoadPP').subscribe({
      next: (res: string) => {
        this.load_label = res;
      }
    });
    this.translate.get('ClinS').subscribe({
      next: (res: string) => {
        this.clins_label = res;
      }
    });
    this.translate.get('Meas').subscribe({
      next: (res: string) => {
        this.meas_label = res;
      }
    });
    this.translate.get('Surv').subscribe({
      next: (res: string) => {
        this.surv_label = res;
      }
    });
    this.translate.get('Rept').subscribe({
      next: (res: string) => {
        this.rept_label = res;
      }
    });
    this.translate.get('Proj').subscribe({
      next: (res: string) => {
        this.proj_label = res;
      }
    });
    this.translate.get('Grop').subscribe({
      next: (res: string) => {
        this.grop_label = res;
      }
    });
    this.translate.get('User').subscribe({
      next: (res: string) => {
        this.user_label = res;
      }
    });
    this.translate.get('Pat').subscribe({
      next: (res: string) => {
        this.pat_label = res;
      }
    });
    this.translate.get('Sec').subscribe({
      next: (res: string) => {
        this.sec_label = res;
      }
    });
    this.translate.get('Adm').subscribe({
      next: (res: string) => {
        this.adm_label = res;
      },
      complete: () => {
        this.updateNodes();
      }
    });
  }
}
